import { render, staticRenderFns } from "./cms-admin.vue?vue&type=template&id=c9991ab4"
import script from "./cms-admin.vue?vue&type=script&lang=js"
export * from "./cms-admin.vue?vue&type=script&lang=js"
import style0 from "./cms-admin.vue?vue&type=style&index=0&id=c9991ab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports